(function () {
  console.log('product-variant-callback: Script loaded, document.readyState:', document.readyState);
  function collectSelectedOptions(container) {
    // Mirror Dawn's VariantSelects.selectedOptionValues: dataset.optionValueId of selected/checked
    var nodes = container.querySelectorAll('variant-selects select option[selected], variant-radios fieldset input:checked');
    return Array.prototype.map.call(nodes, function (node) {
      return node.dataset ? node.dataset.optionValueId : undefined;
    }).filter(function (v) { return v != null; });
  }

  function collectSelectedOptionsKeyValue(container) {
    var results = [];

    // Radios
    container.querySelectorAll('variant-radios fieldset').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var name = legend ? legend.textContent.replace(/:\s*$/, '').trim() : null;
      var input = fieldset.querySelector('input[type="radio"]:checked');
      if (!input) return;
      var id = input.dataset ? input.dataset.optionValueId : null;
      var value = input.value != null ? String(input.value) : null;
      if (name && value) results.push({ name: name, value: value, id: id });
    });

    // Dropdowns
    container.querySelectorAll('variant-selects select').forEach(function (select) {
      var nameAttr = select.getAttribute('name');
      var bracketMatch = nameAttr && nameAttr.match(/^options\[(.*)\]$/);
      var name = bracketMatch ? bracketMatch[1] : null;
      var opt = select.selectedOptions && select.selectedOptions[0];
      if (!opt) return;
      var id = opt.dataset ? opt.dataset.optionValueId : null;
      // prefer option text for human-readable value
      var value = (opt.textContent || opt.value || '').trim();
      if (name && value) results.push({ name: name, value: value, id: id });
    });

    return results;
  }

  function buildDetail(container, sectionId, variantId, variant) {
    var keyValues = collectSelectedOptionsKeyValue(container);
    var map = {};
    keyValues.forEach(function (kv) { map[kv.name] = { value: kv.value, id: kv.id }; });
    return {
      container: container,
      sectionId: sectionId,
      variantId: variantId,
      selectedOptions: collectSelectedOptions(container),
      selectedOptionsKeyValue: keyValues,
      selectedOptionsMap: map,
      variant: variant || null,
    };
  }

  function getVariantId(container) {
    const idInput = container.querySelector('form[action*="/cart/add"] input[name="id"]');
    return idInput && idInput.value ? idInput.value.toString() : null;
  }

  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    return variantFromUrl ? variantFromUrl.toString() : null;
  }

  function emitInit(detail) {
    console.log('product-variant-callback: emitInit called with detail:', detail);
    window.dispatchEvent(new CustomEvent('product-variant:onload', { detail: detail }));
    if (typeof window.productVariantOnLoad === 'function') {
      try {
        console.log('product-variant-callback: calling window.productVariantOnLoad');
        window.productVariantOnLoad(detail);
      } catch (e) {
        console.error('product-variant-callback: error in productVariantOnLoad:', e);
      }
    } else {
      console.log('product-variant-callback: window.productVariantOnLoad is not a function');
    }
  }

  function emitChange(detail) {
    window.dispatchEvent(new CustomEvent('product-variant:change', { detail: detail }));
    if (typeof window.productVariantOnChange === 'function') {
      try {
        window.productVariantOnChange(detail);
      } catch (e) {}
    }
  }

  function handleInitFor(container) {
    if (!container) {
      console.log('product-variant-callback: handleInitFor called with no container');
      return;
    }
    console.log('product-variant-callback: handleInitFor called with container:', container);
    const sectionId = container.dataset.section || null;
    const variantId = getVariantIdFromUrl(); // Use URL method for onload
    console.log('product-variant-callback: sectionId:', sectionId, 'variantId:', variantId);
    emitInit(buildDetail(container, sectionId, variantId));
  }

  function setupSubscriptions() {
    // Wait for dependencies to be available
    function trySetupSubscriptions() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          const sectionId = event && event.data ? event.data.sectionId : null;
          const variant = event && event.data ? event.data.variant : null;
          const container = sectionId
            ? document.querySelector('product-info[data-section="' + sectionId + '"]')
            : null;
          const variantId = variant && variant.id ? variant.id.toString() : null;
          emitChange(buildDetail(container, sectionId, variantId, variant));
        });
      } else {
        // Retry after a short delay if dependencies aren't ready yet
        setTimeout(trySetupSubscriptions, 10);
      }
    }
    trySetupSubscriptions();
  }

  document.addEventListener(
    'product-info:loaded',
    function (e) {
      console.log('product-variant-callback: product-info:loaded event received', e.target);
      var container = (e.target && e.target.closest && e.target.closest('product-info')) || e.target;
      handleInitFor(container);
    },
    { once: false }
  );

  // Function to initialize all product-info elements
  function initializeAllProductInfo() {
    console.log('product-variant-callback: Initializing all product-info elements');
    document.querySelectorAll('product-info').forEach(function (container) {
      handleInitFor(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllProductInfo();
      setupSubscriptions();
    });
  } else {
    initializeAllProductInfo();
    setupSubscriptions();
  }

  // Additional fallback: try again after a short delay to catch any late-loading elements
  setTimeout(function() {
    console.log('product-variant-callback: Fallback initialization');
    initializeAllProductInfo();
  }, 100);
})();


